import LOGIN from "./login";
import SIDEBAR from "./sidebar";
import HEADER from "./header";
import MY_CLASSES from "./myClasses";
import FEEDBACK_MESSAGES from "./feedback";
import GENERAL from "./general";
import EDIT_PROFILE from "./editProfile";
import NOTIFICATIONS from "./notifications";


const MESSAGES = {
	LOGIN,
	SIDEBAR,
	HEADER,
	MY_CLASSES,
	NOTIFICATIONS,
	FEEDBACK_MESSAGES,
	GENERAL,
	EDIT_PROFILE
};

export default MESSAGES;